var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('t-card',{staticStyle:{"height":"calc(89vh - 19px)","width":"100%"}},[_c('h1',[_vm._v("内容検討中…")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }